// threshold is the aspect ratio at which should start scaling. This is probably roughly the intended assetWidth / viewportHeight
// minValue sets a minimum scale value. Setting this value causes less scaledown for the asset. For example: the map uses
// this so it doesn't get too tiny (it allows to overflow a bit on very tall screens)
// As a simple example: if you have an asset somewhat fitting into a square (aspect ratio 1.0) and are trying to make it
// fit the screen nicely, you'd probably want to start scaling it down when the screen aspect ratio < 1.0. Similar to
// other aspect ratios. That's the threshold value.
import { useThree } from '@react-three/fiber';
import { useMemo } from 'react';

export default function (threshold: number): number
{
  const { size } = useThree();
  const value = useMemo(() =>
  {
    const aspect = size.width / size.height;
    // if aspect === threshold, scale = 1
    // if aspect = 0, scale = 0
    return Math.min(aspect / threshold, 1.0);
  }, [ size.height, size.width, threshold ]);

  return value;
}
